import closeDropdown from "./closeDropdown";
import { DROPDOWN_OPTION_CLASS_NAME } from "./constants";
import syncOptionStates from "./syncOptionStates";
import syncSelectedLabel from "./syncSelectedLabel";

const buildOptionButton = (
  optionElement: HTMLOptionElement,
  selectElement: HTMLSelectElement,
  dropdownButton: HTMLButtonElement,
  dropdownMenu: HTMLDivElement
) => {
  const optionButton = document.createElement("button");
  optionButton.type = "button";
  optionButton.className = DROPDOWN_OPTION_CLASS_NAME;
  optionButton.textContent = optionElement.text;
  optionButton.dataset.optionValue = optionElement.value;
  optionButton.setAttribute("role", "option");

  optionButton.addEventListener("click", () => {
    selectElement.value = optionElement.value;
    selectElement.dispatchEvent(new Event("change", { bubbles: true }));
    syncSelectedLabel(selectElement, dropdownButton);
    syncOptionStates(selectElement, dropdownMenu);
    closeDropdown(dropdownButton, dropdownMenu);
  });

  return optionButton;
};

export default buildOptionButton;
